import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Timeline from '@/pages/Timeline';
import Calendar from '@/pages/Calendar';
import CutePhrases from '@/pages/CutePhrases';
import AddMemory from '@/pages/AddMemory';
import MemoryDetail from '@/pages/MemoryDetail';
import Settings from '@/pages/Settings';
import Search from '@/pages/Search';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="timeline" element={<Timeline />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="cute-phrases" element={<CutePhrases />} />
        <Route path="add" element={<AddMemory />} />
        <Route path="edit/:id" element={<AddMemory />} />
        <Route path="memory/:id" element={<MemoryDetail />} />
        <Route path="settings" element={<Settings />} />
        <Route path="search" element={<Search />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
